import { render, staticRenderFns } from "./mod1.vue?vue&type=template&id=6d2eb765&scoped=true&"
import script from "./mod1.vue?vue&type=script&lang=js&"
export * from "./mod1.vue?vue&type=script&lang=js&"
import style0 from "./mod1.vue?vue&type=style&index=0&id=6d2eb765&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d2eb765",
  null
  
)

export default component.exports